export const semaphore = (payload) => {
    // @ts-ignore
    const { SemaphoreJavascriptChannel } = window

    SemaphoreJavascriptChannel.postMessage(JSON.stringify(payload))
}

export const commands = Object.freeze({
    webview: {
        command: "webview",
        reload: "reload",
    },
    iap: {
        command: "iap",
        getOfferings: "getOfferings",
        subscribe: "subscribe",
        restore: "restore",
    },
    hook: {
        command: "hook",
        mounted: "mounted",
    },
    review: {
        command: "review",
    },
    launchUrl: {
        command: "launchUrl",
    },
    share: {
        command: "share",
    },
    analytics: {
        command: "analytics",
        logEvent: "logEvent",
        setCurrentScreen: "setCurrentScreen",
        setUserProperty: "setUserProperty",
    },
    wakelock: {
        command: "wakelock",
        enableWakelock: "enable",
        disableWakelock: "disable",
    }
})
